<div class="bg-white p-xl-5 p-2">
  <div class="border-bottom border-gray">
    <button type="button" class="btn btn-icons float-start" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h3 *ngIf="!assessment?.id" class="text-end text-secondary pb-2">Création d'un diagnostic</h3>
    <h3 *ngIf="assessment?.id" class="text-end text-secondary pb-2">Diagnostic du {{ assessment.creationDateInterview | date }}</h3>
  </div>

  <form *ngIf="assessmentForm" [formGroup]="assessmentForm">
    <div class="modal-body">
      <!-- ********************************************************************************************* -->
      <!-- * HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADE * -->
      <!-- * HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADER HEADE * -->
      <!-- ********************************************************************************************* -->

      <div class="row">
        <!-- Interview date  -->
        <div class="mb-3 col-12 col-lg-4">
          <label class="required">Date d'entretien</label>
          <app-datepicker
            id="fieldCreationDateInterview"
            formControlName="creationDateInterview"
            [invalid]="submitted && fcAss.creationDateInterview.invalid"
          >
          </app-datepicker>
          <small *ngIf="submitted && fcAss?.creationDateInterview?.errors?.required" class="form-text text-danger"> La date est requise. </small>
          <small *ngIf="fcAss?.creationDateInterview?.errors?.dateFormat" class="form-text text-danger"> La date est invalide. </small>
        </div>

        <!-- Status -->
        <div class="mb-3 col-12 col-lg-4">
          <label class="text-secondary required">Statut</label>
          <select class="form-select" formControlName="status" (change)="onStatusChange()" [class.is-invalid]="submitted && fcAss.status.invalid">
            <option *ngFor="let status of statusMap | keyvalue: StringUtils.stringAscOrder" [ngValue]="status.key">
              {{ status.value }}
            </option>
          </select>
          <small *ngIf="submitted && fcAss?.status?.errors?.required" class="form-text text-danger"> Le statut est requis. </small>
        </div>

        <!-- Status update date -->
        <div class="mb-3 col-12 col-lg-4">
          <label class="text-secondary">Date MAJ statut diagnostic</label>
          <app-datepicker id="fieldUpdateStatusDate" formControlName="updateStatusDate"></app-datepicker>
        </div>

        <!-- Context -->
        <div class="mb-3 col-12 col-lg-8">
          <label class="text-secondary required">Contexte de l'entretien</label>
          <select class="form-select" formControlName="context" [class.is-invalid]="submitted && fcAss.context.invalid">
            <option *ngFor="let context of contextMap | keyvalue: assessmentContextSort" [ngValue]="context.key">
              {{ context.value }}
            </option>
          </select>
          <small *ngIf="submitted && fcAss?.context?.errors?.required" class="form-text text-danger"> Le contexte est requis. </small>
        </div>
      </div>

      <!-- ********************************************************************************************* -->
      <!-- * DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL * -->
      <!-- * DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL DETAIL * -->
      <!-- ********************************************************************************************* -->

      <div class="card border-1 card-border-radius-0" formGroupName="detailForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">État civil, contact, adresse</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p><strong>État civil - Coordonnées</strong></p>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <!-- ********************************************************************************************* -->
                        <!-- Recipient number -->
                        <div class="mb-3 text-secondary col-12 col-lg-4">
                          <label>N° allocataire CAF / MSA</label>
                          <input type="text" class="form-control" formControlName="recipientNumber" />
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Title -->
                      <div class="row mt-4">
                        <div class="col-4 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="madam" type="radio" class="form-check-input" formControlName="title" value="Madam" />
                            <label for="madam" class="form-check-label">Madame</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="mister" type="radio" class="form-check-input" formControlName="title" value="Mister" />
                            <label for="mister" class="form-check-label">Monsieur</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Usual name -->
                      <div class="row mt-2">
                        <div class="mb-3 text-secondary col-12 col-lg-4">
                          <label>Nom</label>
                          <input type="text" class="form-control" formControlName="usualName" />
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- First name -->
                        <div class="mb-3 text-secondary col-12 col-lg-4">
                          <label>Prénom</label>
                          <input type="text" class="form-control" formControlName="firstName" />
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Birth date -->
                        <div class="mb-3 text-secondary col-12 col-lg-4">
                          <label>Date de naissance</label>
                          <app-datepicker id="fieldBirthDate" formControlName="birthDate"> </app-datepicker>
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Birth city -->
                        <div class="mb-3 text-secondary col-12 col-lg-4">
                          <label>Ville de naissance</label>
                          <input type="text" class="form-control" formControlName="birthCity" />
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Nationality -->
                        <div class="mb-3 text-secondary col-12 col-lg-4">
                          <label>Nationalité</label>
                          <select class="form-select" formControlName="nationality">
                            <option [ngValue]="frDet.nationality" [selected]="true">
                              {{
                                [nationality.IodasRecovery, nationality.AbcRecovery].includes(labelsByNationality.get(frDet.nationality))
                                  ? ''
                                  : labelsByNationality.get(frDet.nationality)
                              }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Valid identity documents -->
                      <div class="row mt-4">
                        <label>Pièce d’identité en cours de validité (CNI, passeport ou titre de séjour) ?</label>
                        <div class="col-4 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="validIdentityDocumentYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="validIdentityDocument"
                              [value]="true"
                            />
                            <label for="validIdentityDocumentYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="validIdentityDocumentNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="validIdentityDocument"
                              [value]="false"
                            />
                            <label for="validIdentityDocumentNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Renewal in progress -->
                      <div *ngIf="fvDet.validIdentityDocument === false" class="row mt-2">
                        <div class="col-8 col-lg-8">
                          <label>Renouvellement en cours ?</label>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="renewalInProgressYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="renewalInProgress"
                              [value]="true"
                            />
                            <label for="renewalInProgressYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="renewalInProgressNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="renewalInProgress"
                              [value]="false"
                            />
                            <label for="renewalInProgressNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Renewal help needed -->
                      <div *ngIf="fvDet.validIdentityDocument === false" class="row mt-2">
                        <div class="col-8 col-lg-8">
                          <label>Si oui, besoin d'aide dans cette démarche ?</label>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="renewalHelpNeededYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="renewalHelpNeeded"
                              [value]="true"
                            />
                            <label for="renewalHelpNeededYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="renewalHelpNeededNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="renewalHelpNeeded"
                              [value]="false"
                            />
                            <label for="renewalHelpNeededNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-4">
                        <!-- ********************************************************************************************* -->
                        <!-- Address -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
                          <label class="required">Adresse de résidence</label>
                          <input
                            type="text"
                            class="form-control"
                            formControlName="address"
                            [class.is-invalid]="submitted && fcDet?.address?.errors?.required"
                          />
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Additionnal address -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
                          <label>Complément d'adresse</label>
                          <input type="text" class="form-control" formControlName="additionalAddress" placeholder="Bâtiment, BP, ..." />
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- City -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                          <label class="required">Ville</label>
                          <input
                            #input
                            type="text"
                            class="form-control"
                            autocomplete="off"
                            formControlName="city"
                            [ngbTypeahead]="searchCity"
                            [inputFormatter]="inputFormat"
                            [resultFormatter]="resultFormat"
                            [editable]="false"
                            (selectItem)="onSelectCity($event, input)"
                            (blur)="onBlurCity(input)"
                            [class.is-invalid]="(submitted && fcDet?.city?.errors?.required) || (submitted && fcDet?.city?.errors?.pattern)"
                          />
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Postal code -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-3">
                          <label class="required">Code postal</label>
                          <input type="text" class="form-control" formControlName="postalCode" [readonly]="true" />
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- QPV -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
                          <label>Quartier QPV / QVA</label>
                          <select class="form-select" formControlName="qpvId">
                            <option [ngValue]=""></option>
                            <option *ngFor="let qpv of qpvs" [ngValue]="qpv.id">
                              {{ qpv.label }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Phone / SMS -->
                      <div class="row mt-4">
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-4">
                          <label>Numéro téléphone fixe</label>
                          <input type="text" class="form-control" formControlName="landlineNumber" />
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-4">
                          <label>Numéro téléphone mobile</label>
                          <input type="text" class="form-control" formControlName="cellPhoneNumber" />
                          <div class="form-check form-check-inline">
                            <input id="authorize-sms" type="checkbox" class="form-check-input" formControlName="sms" />
                            <label class="custom-control-label" for="authorize-sms">Autorisation SMS</label>
                          </div>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-4">
                          <label>Adresse email</label>
                          <input type="text" class="form-control" formControlName="emailAddress" />
                          <div class="form-check form-check-inline">
                            <input id="authorize-email" type="checkbox" class="form-check-input" formControlName="email" />
                            <label class="custom-control-label" for="authorize-email">Autorisation Email</label>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Situation familiale</strong></p>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <!-- ********************************************************************************************* -->
                        <!-- Marital status -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
                          <label class="required">Situation familiale</label>
                          <select class="form-select" formControlName="maritalStatus">
                            <option *ngFor="let maritalStatus of maritalStatuses | keyvalue" [ngValue]="maritalStatus.key">
                              {{ maritalStatus.value }}
                            </option>
                          </select>
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Single parent -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-6">
                          <div class="row">
                            <label>Parent isolé</label>
                            <div class="col-4 col-lg-3">
                              <div class="form-check form-check-inline">
                                <input id="singleParentYes" type="radio" class="form-check-input" formControlName="singleParent" [value]="true" />
                                <label for="singleParentYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-3">
                              <div class="form-check form-check-inline">
                                <input id="singleParentNo" type="radio" class="form-check-input" formControlName="singleParent" [value]="false" />
                                <label for="singleParentNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Partner name -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-4">
                          <label>Nom du conjoint</label>
                          <input type="text" class="form-control" formControlName="partnerName" />
                          <small *ngIf="submitted && fcDet?.partnerName?.errors?.pattern" class="form-text text-danger">
                            Les caractères spéciaux et les numéros ne sont pas autorisés.
                          </small>
                          <small *ngIf="fcDet?.partnerName?.errors?.maxlength" class="form-text text-danger">
                            La taille maximale est de 30 caractères.
                          </small>
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Partner situation -->
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-8">
                          <label>Situation scolaire ou professionnelle du conjoint</label>
                          <input type="text" class="form-control" formControlName="partnerSituation" />
                          <small *ngIf="fcDet?.partnerSituation?.errors?.maxlength" class="form-text text-danger">
                            La taille maximale est de 30 caractères.
                          </small>
                        </div>

                        <div class="row mt-4">
                          <div class="col-12 col-lg-12">
                            <p><strong>Enfants à charge</strong></p>
                          </div>
                        </div>

                        <!-- ********************************************************************************************* -->
                        <!-- Children count -->
                        <div class="row mt-2">
                          <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-4">
                            <label>Nombre d'enfants</label>
                            <input
                              type="number"
                              class="form-control"
                              formControlName="childrenCount"
                              maxlength="2"
                              [class.is-invalid]="submitted && fcDet?.childrenCount?.errors?.pattern"
                            />
                            <small *ngIf="submitted && fcDet?.childrenCount?.errors?.pattern" class="form-text text-danger">
                              Seuls les nombres sont autorisés.
                            </small>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Children  -->

                      <div class="row mt-2">
                        <app-dynamic-form
                          #children
                          class="col-12"
                          title=""
                          [data]="assessment.children"
                          [showSeparator]="false"
                          [fields]="childrenFields"
                          [validators]="validators"
                          [asyncValidators]="asyncValidators"
                          [validatorsMessageTemplate]="validatorsTemplate"
                          [disabled]="!userCanUpdate"
                          noGroupText="Il n'y a pas d'enfant à charge renseigné. Cliquez sur le bouton + pour en ajouter."
                        >
                          <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Âge</label>
                              <select class="form-select" formControlName="age" [class.is-invalid]="submitted && group?.controls.age.invalid">
                                <option *ngFor="let age of childAgeMap | keyvalue: assessmentChildAgeSort" [ngValue]="age.key">
                                  {{ age.value }}
                                </option>
                              </select>
                              <small *ngIf="submitted && group?.controls?.age?.errors?.required" class="form-text text-danger">
                                L'âge est requis.
                              </small>
                            </div>
                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Situation</label>
                              <select
                                class="form-select"
                                formControlName="situation"
                                [class.is-invalid]="submitted && group?.controls.situation.invalid"
                              >
                                <option
                                  *ngFor="let situation of childSituationMap | keyvalue: assessmentChildSituationSort"
                                  [ngValue]="situation.key"
                                >
                                  {{ situation.value }}
                                </option>
                              </select>
                              <small *ngIf="submitted && group?.controls?.situation?.errors?.required" class="form-text text-danger">
                                La situation est requise.
                              </small>
                            </div>
                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Compléments</label>
                              <input
                                type="text"
                                class="form-control me-3 rounded"
                                formControlName="comment"
                                [class.is-invalid]="submitted && group?.controls?.comment?.invalid"
                              />
                              <small *ngIf="group.controls?.comment?.errors?.maxlength" class="form-text text-danger">
                                La taille maximale est de 30 caractères.
                              </small>
                            </div>
                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">
                                Présent au domicile
                              </label>
                              <div class="input-group">
                                <select
                                  class="form-select me-3 rounded"
                                  formControlName="liveAtFamilyHome"
                                  [class.is-invalid]="submitted && group?.controls.liveAtFamilyHome.invalid"
                                >
                                  <option [ngValue]="true">Oui</option>
                                  <option [ngValue]="false">Non</option>
                                </select>
                                <button
                                  type="button"
                                  ngbTooltip="Supprimer"
                                  placement="left"
                                  class="btn btn-outline-primary rounded"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupRemoved(groupIndex)"
                                >
                                  <fa-icon icon="trash-alt"></fa-icon>
                                </button>
                                <small *ngIf="submitted && group?.controls?.liveAtFamilyHome?.errors?.required" class="form-text text-danger">
                                  Le champ est obligatoire.
                                </small>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                            <div class="row">
                              <div class="col-12 d-flex justify-content-between">
                                <p>
                                  <strong>{{ title }}</strong>
                                </p>
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  ngbTooltip="Ajouter"
                                  placement="left"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupAdded()"
                                >
                                  <fa-icon icon="plus"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                        </app-dynamic-form>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Child in progress -->

                      <div class="row mt-4">
                        <div class="col-8 col-lg-8">
                          <label>Attendez-vous un enfant ?</label>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="childInProgressYes" type="radio" class="form-check-input" formControlName="childInProgress" [value]="true" />
                            <label for="childInProgressYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="childInProgressNo" type="radio" class="form-check-input" formControlName="childInProgress" [value]="false" />
                            <label for="childInProgressNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Is helper -->

                      <div class="row mt-4">
                        <div class="col-8 col-lg-8">
                          <label>Êtes-vous en situation d'aidant(e) ?</label>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="isHelperYes" type="radio" class="form-check-input" formControlName="isHelper" name="isHelper" [value]="true" />
                            <label for="isHelperYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="isHelperNo" type="radio" class="form-check-input" formControlName="isHelper" name="isHelper" [value]="false" />
                            <label for="isHelperNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Foreign parents -->

                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <label>Un de vos deux parents est-il né dans un pays actuellement hors de l’Union Européenne ?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="foreignParentsYes" type="radio" class="form-check-input" formControlName="foreignParents" value="true" />
                            <label for="foreignParentsYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="foreignParentsNo" type="radio" class="form-check-input" formControlName="foreignParents" value="false" />
                            <label for="foreignParentsNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-6 col-lg-6">
                          <div class="form-check form-check-inline">
                            <input
                              id="foreignParentsUnknown"
                              type="radio"
                              class="form-check-input"
                              formControlName="foreignParents"
                              value="unknown"
                            />
                            <label for="foreignParentsUnknown" class="form-check-label">Ne souhaite pas répondre / ne sait pas</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Family barriers -->

                      <div class="row mt-4">
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-12">
                          <label>Avez-vous des difficultés familiales qui pourraient freiner vos démarches ?</label>
                          <textarea formControlName="familyBarriers" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ********************************************************************************************* -->
      <!-- * Validation -->

      <div class="ms-auto">
        <small *ngIf="submitted && (assessmentForm.invalid || detailForm.invalid || children.form.invalid)" class="form-text text-danger">
          Le formulaire n'est pas correctement complété.
        </small>
      </div>
      <div class="row mt-4"></div>

      <!-- ********************************************************************************************* -->
      <!-- * GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOB * -->
      <!-- * GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOBAL-SITUATION GLOB * -->
      <!-- ********************************************************************************************* -->

      <div class="card border-1 card-border-radius-0" formGroupName="globalSituationForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Votre situation globale</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <!-- ********************************************************************************************* -->
                      <!-- * Claim RSA -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Qu'est ce qui vous a conduit à demander le RSA ?</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="claimRsaInsufRes" type="checkbox" class="form-check-input" formControlName="claimRsaInsufRes" />
                            <label class="form-check-label" for="claimRsaInsufRes">Ressources insuffisantes</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="claimRsaNoRes" type="checkbox" class="form-check-input" formControlName="claimRsaNoRes" />
                            <label class="form-check-label" for="claimRsaNoRes">Absence de ressources</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input
                              id="claimRsaNoMoreUnemployRights"
                              type="checkbox"
                              class="form-check-input"
                              formControlName="claimRsaNoMoreUnemployRights"
                            />
                            <label class="form-check-label" for="claimRsaNoMoreUnemployRights">Fin du droit indemnités chômage</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="claimRsaNoMoreUnemploy" type="checkbox" class="form-check-input" formControlName="claimRsaNoMoreUnemploy" />
                            <label class="form-check-label" for="claimRsaNoMoreUnemploy"
                              >Fin d’activité professionnelle de la personne et/ou du conjoint</label
                            >
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="claimRsaRefugeeClaimant" type="checkbox" class="form-check-input" formControlName="claimRsaRefugeeClaimant" />
                            <label class="form-check-label" for="claimRsaRefugeeClaimant">Demandeur(se) d’asile</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-3">
                          <div class="form-check">
                            <input id="claimRsaOther" type="checkbox" class="form-check-input" formControlName="claimRsaOther" />
                            <label class="form-check-label" for="claimRsaOther">Autre (précisez)</label>
                          </div>
                        </div>
                        <div class="col-9">
                          <input type="text" class="form-control" formControlName="claimRsaOtherComment" />
                          <small *ngIf="fcGSit?.claimRsaOtherComment?.errors?.maxlength" class="form-text text-danger">
                            La taille maximale est de 30 caractères.
                          </small>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Activity -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Aujourd'hui, quelle est votre situation ?</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>En activité ?</label>
                          <div class="row mt-2">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input id="isActiveYes" type="radio" class="form-check-input" formControlName="isActive" [value]="true" />
                                <label for="isActiveYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input id="isActiveNo" type="radio" class="form-check-input" formControlName="isActive" [value]="false" />
                                <label for="isActiveNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <div *ngIf="fvGSit.isActive === true">
                            <label>Si oui</label>
                            <select class="form-select" formControlName="activity" [class.is-invalid]="submitted && group?.controls.activity.invalid">
                              <option *ngFor="let activity of activityMap | keyvalue: assessmentActivitySort" [ngValue]="activity.key">
                                {{ activity.value }}
                              </option>
                            </select>
                          </div>
                          <div *ngIf="fvGSit.isActive === false">
                            <label>Si non</label>
                            <select
                              class="form-select"
                              formControlName="unactivity"
                              [class.is-invalid]="submitted && group?.controls.unactivity.invalid"
                            >
                              <option *ngFor="let unactivity of unactivityMap | keyvalue: assessmentUnactivitySort" [ngValue]="unactivity.key">
                                {{ unactivity.value }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- SIAE -->
                      <div class="row mt-2">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Agrément SIAE</label>
                          <div class="row">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="accreditationSIAEYes"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="accreditationSIAE"
                                  [value]="true"
                                />
                                <label for="accreditationSIAEYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="accreditationSIAENo"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="accreditationSIAE"
                                  [value]="false"
                                />
                                <label for="accreditationSIAENo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Fin d'agrément SIAE</label>
                          <app-datepicker id="fieldBirthDate" formControlName="accreditationSIAEDate"> </app-datepicker>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- RQTH -->
                      <div class="row mt-2">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>RQTH</label>
                          <div class="row">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="accreditationRQTHYes"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="accreditationRQTH"
                                  [value]="true"
                                />
                                <label for="accreditationRQTHYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="accreditationRQTHNo"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="accreditationRQTH"
                                  [value]="false"
                                />
                                <label for="accreditationRQTHNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Fin de validité RQTH</label>
                          <app-datepicker id="fieldBirthDate" formControlName="accreditationRQTHDate"> </app-datepicker>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- AAH -->
                      <div class="row mt-2">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Êtes-vous bénéficiaire de l'AAH</label>
                          <div class="row">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="accreditationAAHYes"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="accreditationAAH"
                                  [value]="true"
                                />
                                <label for="accreditationAAHYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="accreditationAAHNo"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="accreditationAAH"
                                  [value]="false"
                                />
                                <label for="accreditationAAHNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Fin AAH</label>
                          <app-datepicker id="fieldBirthDate" formControlName="accreditationAAHDate"> </app-datepicker>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Has worked -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Avez-vous déjà travaillé ?</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <div class="row">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input id="hasWorkedYes" type="radio" class="form-check-input" formControlName="hasWorked" [value]="true" />
                                <label for="hasWorkedYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input id="hasWorkedNo" type="radio" class="form-check-input" formControlName="hasWorked" [value]="false" />
                                <label for="hasWorkedNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="fvGSit.hasWorked === true" class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Si oui, il y a combien de temps ?</label>
                          <select
                            class="form-select"
                            formControlName="howLongHasWorked"
                            [class.is-invalid]="submitted && group?.controls.howLongHasWorked.invalid"
                          >
                            <option
                              *ngFor="let howLongHasWorked of howLongHasWorkedMap | keyvalue: assessmentHowLongHasWorkedSort"
                              [ngValue]="howLongHasWorked.key"
                            >
                              {{ howLongHasWorked.value }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Pro exp -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Expériences significatives</strong></p>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <app-dynamic-form
                          #proExps
                          class="col-12"
                          title=""
                          [data]="assessment.proExps"
                          [showSeparator]="false"
                          [fields]="proExpsFields"
                          [validators]="validators"
                          [asyncValidators]="asyncValidators"
                          [validatorsMessageTemplate]="validatorsTemplate"
                          [disabled]="!userCanUpdate"
                          noGroupText="Il n'y a pas d'expérience renseignée. Cliquez sur le bouton + pour en ajouter."
                        >
                          <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                            <div class="text-secondary mb-2 col-12 col-lg-8" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Poste</label>
                              <input
                                type="text"
                                class="form-control me-3 rounded"
                                formControlName="job"
                                [class.is-invalid]="submitted && group?.controls?.job?.invalid"
                              />
                              <small *ngIf="submitted && group?.controls?.job?.errors?.required" class="form-text text-danger">
                                Le champ est obligatoire.
                              </small>
                            </div>

                            <div class="text-secondary mb-2 col-12 col-lg-4" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Durée</label>
                              <div class="input-group">
                                <select
                                  class="form-select me-3 rounded"
                                  formControlName="duration"
                                  [class.is-invalid]="submitted && group?.controls.duration.invalid"
                                >
                                  <option
                                    *ngFor="let duration of proExpDurationMap | keyvalue: assessmentProExpDurationSort"
                                    [ngValue]="duration.key"
                                  >
                                    {{ duration.value }}
                                  </option>
                                </select>
                                <button
                                  type="button"
                                  ngbTooltip="Supprimer"
                                  placement="left"
                                  class="btn btn-outline-primary rounded"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupRemoved(groupIndex)"
                                >
                                  <fa-icon icon="trash-alt"></fa-icon>
                                </button>
                                <small *ngIf="submitted && group?.controls?.duration?.errors?.required" class="form-text text-danger">
                                  Le champ est obligatoire.
                                </small>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                            <div class="row">
                              <div class="col-12 d-flex justify-content-between">
                                <p>
                                  <strong>{{ title }}</strong>
                                </p>
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  ngbTooltip="Ajouter"
                                  placement="left"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupAdded()"
                                >
                                  <fa-icon icon="plus"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                        </app-dynamic-form>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Job searching -->

                      <!-- Searching for new job -->
                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Recherchez vous un emploi ?</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <div class="row">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="searchingForJobYes"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="searchingForJob"
                                  [value]="true"
                                />
                                <label for="searchingForJobYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="searchingForJobNo"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="searchingForJob"
                                  [value]="false"
                                />
                                <label for="searchingForJobNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div *ngIf="fvGSit.searchingForJob === false" class="mb-3 text-secondary col-12 col-lg-12">
                            <label>Si non, pourquoi ?</label>
                            <input type="text" class="form-control" formControlName="searchingForJobReasonNotTo" />
                          </div>
                        </div>
                      </div>

                      <!-- Ready for new job -->
                      <div class="row mt-4">
                        <div class="mb-3 text-secondary col-12 col-lg-12">
                          <label>Êtes vous disponible pour reprendre une activité professionnelle ?</label>
                          <div class="row">
                            <div class="col-4 col-lg-2">
                              <div class="form-check form-check-inline">
                                <input id="readyForNewJobYes" type="radio" class="form-check-input" formControlName="readyForNewJob" [value]="true" />
                                <label for="readyForNewJobYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-2">
                              <div class="form-check form-check-inline">
                                <input id="readyForNewJobNo" type="radio" class="form-check-input" formControlName="readyForNewJob" [value]="false" />
                                <label for="readyForNewJobNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div class="row">
                          <div *ngIf="fvGSit.readyForNewJob === false" class="mb-3 text-secondary col-12 col-lg-12">
                            <label>Si non, pourquoi ?</label>
                            <input type="text" class="form-control" formControlName="readyForNewJobReasonNotTo" />
                          </div>
                        </div>
                      </div>

                      <!-- Job center -->
                      <div class="row mt-4">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Êtes-vous inscrit à France Travail ?</label>
                          <select
                            class="form-select me-3 rounded"
                            formControlName="jobCenterRegistration"
                            [class.is-invalid]="submitted && fcGSit.jobCenterRegistration.invalid"
                          >
                            <option
                              *ngFor="let item of jobCenterRegistrationMap | keyvalue: assessmentJobCenterRegistrationSort"
                              [ngValue]="item.key"
                            >
                              {{ item.value }}
                            </option>
                          </select>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Depuis quand</label>
                          <app-datepicker id="fieldBirthDate" formControlName="jobCenterLastUpdateDate"> </app-datepicker>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-12">
                          <label>Quelles démarches d'insertion avez-vous engagées ?</label>
                          <textarea formControlName="integrationStepsTaken" type="text" class="form-control"></textarea>
                        </div>
                      </div>

                      <!-- Degree -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Niveau d'études, formations, qualifications</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Niveau d'étude</label>
                          <div class="mb-3 text-secondary">
                            <select class="form-select" formControlName="degreeId" [class.is-invalid]="submitted && fcGSit.degreeId.invalid">
                              <option value=""></option>
                              <option *ngFor="let degree of degrees" [ngValue]="degree.id">
                                {{ degree.label }}
                              </option>
                            </select>
                          </div>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Études à l'étranger ?</label>
                          <div class="row">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input id="studyAbroadYes" type="radio" class="form-check-input" formControlName="studyAbroad" [value]="true" />
                                <label for="studyAbroadYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input id="studyAbroadNo" type="radio" class="form-check-input" formControlName="studyAbroad" [value]="false" />
                                <label for="studyAbroadNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12 col-lg-6">
                          <div class="mb-3 text-secondary">
                            <label>Intitulé du diplôme</label>
                            <input type="text" class="form-control" formControlName="degreeLabel" />
                          </div>
                        </div>
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Diplôme obtenu ?</label>
                          <div class="row">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input id="degreeGainedYes" type="radio" class="form-check-input" formControlName="degreeGained" [value]="true" />
                                <label for="degreeGainedYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input id="degreeGainedNo" type="radio" class="form-check-input" formControlName="degreeGained" [value]="false" />
                                <label for="degreeGainedNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3 text-secondary col-12 col-lg-12">
                          <label>Domaines de formation</label>
                          <div class="mb-3 text-secondary">
                            <ng-select
                              formControlName="trainingAreaIds"
                              [items]="trainingAreas"
                              bindValue="id"
                              bindLabel="label"
                              [multiple]="true"
                              [closeOnSelect]="false"
                            ></ng-select>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Formations -->

                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Formations hors cursus scolaire</strong></p>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <app-dynamic-form
                          #formations
                          class="col-12"
                          title=""
                          [data]="assessment.formations"
                          [showSeparator]="false"
                          [fields]="formationsFields"
                          [validators]="validators"
                          [asyncValidators]="asyncValidators"
                          [validatorsMessageTemplate]="validatorsTemplate"
                          [disabled]="!userCanUpdate"
                          noGroupText="Il n'y a pas de formation renseignée. Cliquez sur le bouton + pour en ajouter."
                        >
                          <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Intitulé</label>
                              <input
                                type="text"
                                class="form-control me-3 rounded"
                                formControlName="label"
                                [class.is-invalid]="submitted && group?.controls?.label?.invalid"
                              />
                            </div>
                            <div class="text-secondary mb-2 col-12 col-lg-4" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Début</label>
                              <app-datepicker id="fieldBeginDate" formControlName="beginDate"></app-datepicker>
                            </div>

                            <div class="text-secondary mb-2 col-12 col-lg-5" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0"> Fin </label>
                              <div class="input-group">
                                <app-datepicker id="fieldEndDate" formControlName="endDate" class="me-3"></app-datepicker>
                                <button
                                  type="button"
                                  ngbTooltip="Supprimer"
                                  placement="left"
                                  class="btn btn-outline-primary rounded"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupRemoved(groupIndex)"
                                >
                                  <fa-icon icon="trash-alt"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                            <div class="row">
                              <div class="col-12 d-flex justify-content-between">
                                <p>
                                  <strong>{{ title }}</strong>
                                </p>
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  ngbTooltip="Ajouter"
                                  placement="left"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupAdded()"
                                >
                                  <fa-icon icon="plus"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                        </app-dynamic-form>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ********************************************************************************************* -->
      <!-- * Validation -->

      <div class="ms-auto">
        <small
          *ngIf="submitted && (assessmentForm.invalid || globalSituationForm.invalid || proExps.form.invalid || formations.form.invalid)"
          class="form-text text-danger"
        >
          Le formulaire n'est pas correctement complété.
        </small>
      </div>
      <div class="row mt-4"></div>

      <!-- ********************************************************************************************* -->
      <!-- * SOCIAL-SITUATION SOCIAL-SITUATION SOCIAL-SITUATION SOCIAL-SITUATION SOCIAL-SITUATION SOCI * -->
      <!-- * SOCIAL-SITUATION SOCIAL-SITUATION SOCIAL-SITUATION SOCIAL-SITUATION SOCIAL-SITUATION SOCI * -->
      <!-- ********************************************************************************************* -->

      <div class="card border-1 card-border-radius-0" formGroupName="socialSituationForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Votre situation sociale</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <!-- ********************************************************************************************* -->
                      <!-- * Residential status -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <strong>Quelle est votre situation par rapport au logement ?</strong>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <div class="mb-3 text-secondary col-12 col-lg-12">
                          <label>Statut d'habitation</label>
                          <select
                            class="form-select me-3 rounded"
                            formControlName="residentialStatus"
                            [class.is-invalid]="submitted && fcSSit.residentialStatus.invalid"
                          >
                            <option value=""></option>
                            <option *ngFor="let item of residentialStatusMap | keyvalue" [ngValue]="item.key">
                              {{ item.value }}
                            </option>
                          </select>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Social exclusion -->

                      <div class="row mt-2">
                        <div class="col-8 col-lg-12">
                          <label>Êtes vous confronté à un problème d'exclusion ?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="socialExclusionYes" type="radio" class="form-check-input" formControlName="socialExclusion" [value]="true" />
                            <label for="socialExclusionYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="socialExclusionNo" type="radio" class="form-check-input" formControlName="socialExclusion" [value]="false" />
                            <label for="socialExclusionNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-8">
                          <div class="form-check form-check-inline">
                            <input
                              id="socialExclusionNoAnswer"
                              type="radio"
                              class="form-check-input"
                              formControlName="socialExclusion"
                              [value]="null"
                            />
                            <label for="socialExclusionNoAnswer" class="form-check-label">Pas de réponse</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Indebtedness -->

                      <div class="row mt-2">
                        <div class="col-8 col-lg-12">
                          <label>Situation d'impayé / endettement ?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="indebtednessYes" type="radio" class="form-check-input" formControlName="indebtedness" [value]="true" />
                            <label for="indebtednessYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="indebtednessNo" type="radio" class="form-check-input" formControlName="indebtedness" [value]="false" />
                            <label for="indebtednessNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-8">
                          <div class="form-check form-check-inline">
                            <input id="indebtednessNoAnswer" type="radio" class="form-check-input" formControlName="indebtedness" [value]="null" />
                            <label for="indebtednessNoAnswer" class="form-check-label">Pas de réponse</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Assistance -->

                      <div class="row mt-4">
                        <div class="col-8 col-lg-12">
                          <strong>Bénéficiez-vous d'une aide ?</strong>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="assistanceYes" type="radio" class="form-check-input" formControlName="assistance" [value]="true" />
                            <label for="assistanceYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="assistanceNo" type="radio" class="form-check-input" formControlName="assistance" [value]="false" />
                            <label for="assistanceNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-8">
                          <div class="form-check form-check-inline">
                            <input id="assistanceNoAnswer" type="radio" class="form-check-input" formControlName="assistance" [value]="null" />
                            <label for="assistanceNoAnswer" class="form-check-label">Pas de réponse</label>
                          </div>
                        </div>
                      </div>

                      <div class="row mt-2" *ngIf="fvSSit.assistance">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="assistedByConseiller" type="checkbox" class="form-check-input" formControlName="assistedByConseiller" />
                            <label class="form-check-label" for="assistedByConseiller">Par un(e) conseiller(e) d'insertion / emploi</label>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-check">
                            <input
                              id="assistedByTravailleurSocial"
                              type="checkbox"
                              class="form-check-input"
                              formControlName="assistedByTravailleurSocial"
                            />
                            <label class="form-check-label" for="assistedByTravailleurSocial">Par un(e) travailleur social(e)</label>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-check">
                            <input id="assistedByAssociation" type="checkbox" class="form-check-input" formControlName="assistedByAssociation" />
                            <label class="form-check-label" for="assistedByAssociation">Par une association</label>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-check">
                            <input id="assistedByFamilleAmis" type="checkbox" class="form-check-input" formControlName="assistedByFamilleAmis" />
                            <label class="form-check-label" for="assistedByFamilleAmis">Par ma famille, mes amis</label>
                          </div>
                        </div>
                        <div class="col-12">
                          <div class="form-check">
                            <input id="assistedByAutre" type="checkbox" class="form-check-input" formControlName="assistedByAutre" />
                            <label class="form-check-label" for="assistedByAutre">Par d'autres personnes ou organismes</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * TransportMode -->

                      <div class="row mt-4">
                        <div class="col-8 col-lg-12">
                          <strong>Quels sont vos moyens et capacités de mobilité ?</strong>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Autonomous mobility -->

                      <div class="row mt-2">
                        <div class="col-8 col-lg-12">
                          <label>Capacité à se déplacer seul(e) ?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="autonomousMobilityYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="autonomousMobility"
                              [value]="true"
                            />
                            <label for="autonomousMobilityYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="autonomousMobilityNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="autonomousMobility"
                              [value]="false"
                            />
                            <label for="autonomousMobilityNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-8">
                          <div class="form-check form-check-inline">
                            <input
                              id="autonomousMobilityNoAnswer"
                              type="radio"
                              class="form-check-input"
                              formControlName="autonomousMobility"
                              [value]="null"
                            />
                            <label for="autonomousMobilityNoAnswer" class="form-check-label">Pas de réponse</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Licence B -->

                      <div class="row mt-2">
                        <div class="col-8 col-lg-12">
                          <label>Permis B ?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="licenceBYes" type="radio" class="form-check-input" formControlName="licenceB" [value]="true" />
                            <label for="licenceBYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="licenceBNo" type="radio" class="form-check-input" formControlName="licenceB" [value]="false" />
                            <label for="licenceBNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-8">
                          <div class="form-check form-check-inline">
                            <input id="licenceBNoAnswer" type="radio" class="form-check-input" formControlName="licenceB" [value]="null" />
                            <label for="licenceBNoAnswer" class="form-check-label">Pas de réponse</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- *  TCL subscription -->

                      <div class="row mt-2">
                        <div class="col-8 col-lg-12">
                          <label>Abonnement TCL ?</label>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="tclSubscriptionYes" type="radio" class="form-check-input" formControlName="tclSubscription" [value]="true" />
                            <label for="tclSubscriptionYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input id="tclSubscriptionNo" type="radio" class="form-check-input" formControlName="tclSubscription" [value]="false" />
                            <label for="tclSubscriptionNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-8">
                          <div class="form-check form-check-inline">
                            <input
                              id="tclSubscriptionNoAnswer"
                              type="radio"
                              class="form-check-input"
                              formControlName="tclSubscription"
                              [value]="null"
                            />
                            <label for="tclSubscriptionNoAnswer" class="form-check-label">Pas de réponse</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Transport modes -->

                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Moyens de transport</strong></p>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <app-dynamic-form
                          #transportModes
                          class="col-12"
                          title=""
                          [data]="assessment.transportModes?.length ? assessment.transportModes : beneficiaryEmployment?.transportModes"
                          [showSeparator]="false"
                          [fields]="transportModesFields"
                          [validators]="validators"
                          [asyncValidators]="asyncValidators"
                          [validatorsMessageTemplate]="validatorsTemplate"
                          [disabled]="!userCanUpdate"
                          noGroupText="Il n'y a pas de moyen de transport renseignée. Cliquez sur le bouton + pour en ajouter."
                        >
                          <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                            <div class="text-secondary mb-2 col-12 col-lg-6" [formGroup]="group">
                              <label class="required" [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0"
                                >Moyen de transport</label
                              >

                              <select
                                class="form-select"
                                formControlName="transportModeId"
                                [class.is-invalid]="submitted && group?.controls.transportModeId.invalid"
                              >
                                <option *ngFor="let transportMode of transportModeMap" [ngValue]="transportMode.id">
                                  {{ transportMode.label }}
                                </option>
                              </select>
                              <small *ngIf="submitted && group?.controls?.transportMode?.errors?.required" class="form-text text-danger">
                                L'information est requise.
                              </small>
                            </div>
                            <div class="text-secondary mb-2 col-12 col-lg-6" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Description</label>
                              <div class="input-group">
                                <input
                                  type="text"
                                  class="form-control me-3 rounded"
                                  formControlName="description"
                                  [class.is-invalid]="submitted && group?.controls?.description?.invalid"
                                />
                                <button
                                  type="button"
                                  ngbTooltip="Supprimer"
                                  placement="left"
                                  class="btn btn-outline-primary rounded"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupRemoved(groupIndex)"
                                >
                                  <fa-icon icon="trash-alt"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                            <div class="row">
                              <div class="col-12 d-flex justify-content-between">
                                <p>
                                  <strong>{{ title }}</strong>
                                </p>
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  ngbTooltip="Ajouter"
                                  placement="left"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupAdded()"
                                >
                                  <fa-icon icon="plus"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                        </app-dynamic-form>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Maximal mobility distance and time -->

                      <div class="row mt-4">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Rayon de mobilité maximum (km)</label>
                          <input type="number" class="form-control" formControlName="maxMobilityDistance" />
                          <small *ngIf="submitted && fcSSit?.maxMobilityDistance?.errors?.pattern" class="form-text text-danger">
                            Seuls les chiffres sont autorisés.
                          </small>
                        </div>
                        <small *ngIf="submitted && fcSSit?.maxMobilityDistance?.errors?.pattern" class="form-text text-danger">
                          Seuls les chiffres sont autorisés.
                        </small>

                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Temps de trajet maximum (min)</label>
                          <input type="number" class="form-control" formControlName="maxMobilityGoToWorkTime" />
                          <small *ngIf="submitted && fcSSit?.maxMobilityGoToWorkTime?.errors?.pattern" class="form-text text-danger">
                            Seuls les chiffres sont autorisés.
                          </small>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ********************************************************************************************* -->
      <!-- * Validation -->

      <div class="ms-auto">
        <small
          *ngIf="submitted && (assessmentForm.invalid || socialSituationForm.invalid || transportModes.form.invalid)"
          class="form-text text-danger"
        >
          Le formulaire n'est pas correctement complété.
        </small>
      </div>
      <div class="row mt-4"></div>

      <!-- ********************************************************************************************* -->
      <!-- * ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIEN * -->
      <!-- * ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIENTATION ORIEN * -->
      <!-- ********************************************************************************************* -->

      <div class="card border-1 card-border-radius-0" formGroupName="orientationForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Vos projets et votre orientation</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <!-- ********************************************************************************************* -->
                      <!-- * Professionnal Project -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Avez-vous un projet professionnel ?</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <div class="row">
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="hasProfessionnalProjectYes"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="hasProfessionnalProject"
                                  [value]="true"
                                />
                                <label for="hasProfessionnalProjectYes" class="form-check-label">Oui</label>
                              </div>
                            </div>
                            <div class="col-4 col-lg-4">
                              <div class="form-check form-check-inline">
                                <input
                                  id="hasProfessionnalProjectNo"
                                  type="radio"
                                  class="form-check-input"
                                  formControlName="hasProfessionnalProject"
                                  [value]="false"
                                />
                                <label for="hasProfessionnalProjectNo" class="form-check-label">Non</label>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Professionnal Project details -->
                      <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-12">
                        <label>Précisez</label>
                        <textarea formControlName="professionnalProjectDetails" type="text" class="form-control"></textarea>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Job Soughts -->

                      <div class="row mt-4">
                        <div class="col-12 col-lg-12">
                          <p><strong>Postes recherchés</strong></p>
                        </div>
                      </div>

                      <div class="row mt-2">
                        <app-dynamic-form
                          #jobSoughts
                          class="col-12"
                          title=""
                          [data]="employmentJobs"
                          [showSeparator]="false"
                          [fields]="jobSoughtsFields"
                          [validators]="validators"
                          [asyncValidators]="asyncValidators"
                          [validatorsMessageTemplate]="validatorsTemplate"
                          [disabled]="!userCanUpdate"
                          noGroupText="Il n'y a pas de postes recherchés. Cliquez sur le bouton + pour en ajouter."
                        >
                          <ng-template let-groupIndex="groupIndex" let-group="group" let-groupRemoved="groupRemoved">
                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Famille</label>
                              <select
                                class="form-select"
                                formControlName="famillyWantedJobType"
                                [class.is-invalid]="submitted && group?.controls?.sector?.errors?.required"
                                (change)="handleSectorChange(group)"
                              >
                                <option value="" hidden></option>
                                <option *ngFor="let sector of sectors" [ngValue]="sector">{{ sector.label }}</option>
                              </select>
                              <small *ngIf="submitted && group?.controls?.sector?.errors?.required" class="form-text text-danger"
                                >La famille est requise.</small
                              >
                            </div>

                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Domaine professionnel</label>
                              <select
                                class="form-select"
                                formControlName="domainWantedJobType"
                                [attr.disabled]="group.controls?.famillyWantedJobType?.value ? null : ''"
                                [class.is-invalid]="submitted && group?.controls?.domainWantedJobType?.errors?.required"
                                (change)="handleDomainChange(group)"
                              >
                                <option value="" hidden></option>
                                <option *ngFor="let domain of group.controls?.famillyWantedJobType?.value?.subValues" [ngValue]="domain">
                                  {{ domain.label }}
                                </option>
                              </select>
                              <small *ngIf="submitted && group?.controls?.domainWantedJobType?.errors?.required" class="form-text text-danger"
                                >Le domaine est requis.</small
                              >
                            </div>

                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Métier</label>
                              <select
                                class="form-select me-3 rounded"
                                formControlName="wantedJobType"
                                [attr.disabled]="group.controls?.domainWantedJobType?.value ? null : ''"
                                [class.is-invalid]="submitted && group?.controls?.wantedJobType?.errors?.required"
                              >
                                <option value="" hidden></option>
                                <option *ngFor="let job of group.controls?.domainWantedJobType?.value?.subValues" [ngValue]="job">
                                  {{ job.label }}
                                </option>
                              </select>
                              <small *ngIf="submitted && group?.controls?.domainWantedJobType?.errors?.required" class="form-text text-danger"
                                >Le domaine est requis.</small
                              >
                            </div>

                            <div class="text-secondary mb-2 col-12 col-lg-3" [formGroup]="group">
                              <label [class.d-xl-none]="groupIndex !== 0" [class.d-lg-none]="groupIndex !== 0">Expérience</label>
                              <div class="input-group">
                                <select
                                  class="form-select me-3 rounded"
                                  formControlName="experienceLength"
                                  [attr.disabled]="group.controls?.wantedJobType?.value ? null : ''"
                                >
                                  <option value="" hidden></option>
                                  <option
                                    *ngFor="let experienceLength of experienceLengthMap | keyvalue: assessmentExperienceLengthSort"
                                    [ngValue]="experienceLength.key"
                                  >
                                    {{ experienceLength.value }}
                                  </option>
                                </select>
                                <button
                                  type="button"
                                  ngbTooltip="Supprimer"
                                  placement="left"
                                  class="btn btn-outline-primary rounded"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupRemoved(groupIndex)"
                                >
                                  <fa-icon icon="trash-alt"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                          <ng-template title-tmp let-title="title" let-groupAdded="groupAdded">
                            <div class="row">
                              <div class="col-12 d-flex justify-content-between">
                                <p>
                                  <strong>{{ title }}</strong>
                                </p>
                                <button
                                  type="button"
                                  class="btn btn-primary"
                                  ngbTooltip="Ajouter"
                                  placement="left"
                                  [disabled]="!userCanUpdate"
                                  (click)="groupAdded()"
                                >
                                  <fa-icon icon="plus"></fa-icon>
                                </button>
                              </div>
                            </div>
                          </ng-template>
                        </app-dynamic-form>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Contract type -->
                      <div class="row">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Quel type de contrat recherchez-vous ?</label>
                          <div class="mb-3 text-secondary">
                            <select
                              class="form-select"
                              formControlName="contractSearchType"
                              [class.is-invalid]="submitted && fcOri.contractSearchType.invalid"
                            >
                              <option value=""></option>
                              <option
                                *ngFor="let contractType of contractTypesMap | keyvalue: assessmentContractTypesSort"
                                [ngValue]="contractType.key"
                              >
                                {{ contractType.value }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Working time -->
                      <div class="row">
                        <div class="mb-3 text-secondary col-12 col-lg-6">
                          <label>Temps de travail</label>
                          <div class="mb-3 text-secondary">
                            <select class="form-select" formControlName="workingTime" [class.is-invalid]="submitted && fcOri.workingTime.invalid">
                              <option value=""></option>
                              <option *ngFor="let workingTime of workingTimeMap | keyvalue: assessmentWorkingTimeSort" [ngValue]="workingTime.key">
                                {{ workingTime.value }}
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * In which domain need help -->
                      <div class="row">
                        <div class="col-12 col-lg-12">
                          <p>
                            <strong>Dans quel(s) domaine(s) auriez-vous besoin d’être aidé(e) pour l’accès à l’emploi ?</strong>
                          </p>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="accessToFormation" type="checkbox" class="form-check-input" formControlName="accessToFormation" />
                            <label class="form-check-label" for="accessToFormation">Accès à la formation</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="housing" type="checkbox" class="form-check-input" formControlName="housing" />
                            <label class="form-check-label" for="housing">Logement</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="health" type="checkbox" class="form-check-input" formControlName="health" />
                            <label class="form-check-label" for="health">Santé</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="famillyOrganisation" type="checkbox" class="form-check-input" formControlName="famillyOrganisation" />
                            <label class="form-check-label" for="famillyOrganisation">Organisation de la vie familiale</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="mobility" type="checkbox" class="form-check-input" formControlName="mobility" />
                            <label class="form-check-label" for="mobility">Mobilité</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="budgetManagement" type="checkbox" class="form-check-input" formControlName="budgetManagement" />
                            <label class="form-check-label" for="budgetManagement">Gestion budgétaire</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="frenchUnderstanding" type="checkbox" class="form-check-input" formControlName="frenchUnderstanding" />
                            <label class="form-check-label" for="frenchUnderstanding">Compréhension de la langue française à l’oral</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input
                              id="readingWritingDifficulties"
                              type="checkbox"
                              class="form-check-input"
                              formControlName="readingWritingDifficulties"
                            />
                            <label class="form-check-label" for="readingWritingDifficulties">Difficultés de lecture et/ou écriture</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="adminDifficulties" type="checkbox" class="form-check-input" formControlName="adminDifficulties" />
                            <label class="form-check-label" for="adminDifficulties">Difficultés administratives</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="numericDifficulties" type="checkbox" class="form-check-input" formControlName="numericDifficulties" />
                            <label class="form-check-label" for="numericDifficulties">Difficultés à utiliser les outils numériques</label>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <div class="form-check">
                            <input id="noDifficulties" type="checkbox" class="form-check-input" formControlName="noDifficulties" />
                            <label class="form-check-label" for="noDifficulties">Pas de difficultés dans ces domaines</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- * Expectations regarding RSA -->
                      <div class="row mt-4">
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-12">
                          <label>Quelles sont vos attentes vis-à-vis de l'accompagnement lié au RSA ?</label>
                          <textarea formControlName="expectationsRegardingRSA" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ********************************************************************************************* -->
      <!-- * Validation -->

      <div class="ms-auto">
        <small *ngIf="submitted && (assessmentForm.invalid || orientationForm.invalid)" class="form-text text-danger">
          Le formulaire n'est pas correctement complété.
        </small>
      </div>
      <div class="row mt-4"></div>

      <!-- ********************************************************************************************* -->
      <!-- * SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT S * -->
      <!-- * SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT SUPPORT S * -->
      <!-- ********************************************************************************************* -->

      <div class="card border-1 card-border-radius-0" formGroupName="supportForm">
        <div class="card-body p-0">
          <div class="table-responsive">
            <div ngbAccordion [closeOthers]="false">
              <div ngbAccordionItem>
                <h2 ngbAccordionHeader>
                  <button ngbAccordionButton class="accordion-button">Accompagnement proposé</button>
                </h2>
                <div ngbAccordionCollapse>
                  <div ngbAccordionBody>
                    <ng-template>
                      <!-- Support proposal -->
                      <div class="mb-3 col-12 col-lg-4">
                        <label class="text-secondary">Proposition de parcours</label>
                        <select class="form-select" formControlName="supportProposal">
                          <option value=""></option>
                          <option
                            *ngFor="let supportProposal of supportProposalMap | keyvalue: StringUtils.stringAscOrder"
                            [ngValue]="supportProposal.key"
                          >
                            {{ supportProposal.value }}
                          </option>
                        </select>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Support acceptance -->

                      <div class="row mt-4">
                        <label>L'allocataire adhère à la proposition / décision d'orientation</label>
                        <div class="col-4 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="supportAcceptanceYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="supportAcceptance"
                              [value]="true"
                            />
                            <label for="supportAcceptanceYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="supportAcceptanceNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="supportAcceptance"
                              [value]="false"
                            />
                            <label for="supportAcceptanceNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-8">
                          <div class="form-check form-check-inline">
                            <input
                              id="supportAcceptanceNoAnswer"
                              type="radio"
                              class="form-check-input"
                              formControlName="supportAcceptance"
                              [value]="null"
                            />
                            <label for="supportAcceptanceNoAnswer" class="form-check-label">Pas de réponse</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Data sharing acceptance -->

                      <div class="row mt-4">
                        <label>Accord pour la transmission des informations au futur référent RSA et France Travail</label>
                        <div class="col-4 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="dataSharingAcceptanceYes"
                              type="radio"
                              class="form-check-input"
                              formControlName="dataSharingAcceptance"
                              [value]="true"
                            />
                            <label for="dataSharingAcceptanceYes" class="form-check-label">Oui</label>
                          </div>
                        </div>
                        <div class="col-4 col-lg-2">
                          <div class="form-check form-check-inline">
                            <input
                              id="dataSharingAcceptanceNo"
                              type="radio"
                              class="form-check-input"
                              formControlName="dataSharingAcceptance"
                              [value]="false"
                            />
                            <label for="dataSharingAcceptanceNo" class="form-check-label">Non</label>
                          </div>
                        </div>
                        <div class="col-2 col-lg-8">
                          <div class="form-check form-check-inline">
                            <input
                              id="dataSharingAcceptanceNoAnswer"
                              type="radio"
                              class="form-check-input"
                              formControlName="dataSharingAcceptance"
                              [value]="null"
                            />
                            <label for="dataSharingAcceptanceNoAnswer" class="form-check-label">Pas de réponse</label>
                          </div>
                        </div>
                      </div>

                      <!-- ********************************************************************************************* -->
                      <!-- Support choice explanation -->

                      <div class="row mt-4">
                        <div class="mb-3 text-secondary col-12 col-lg-12 col-xl-12">
                          <label>
                            Expliquez en quelques lignes (ou mots clés) les points de diagnostic <br />
                            de la situation du/de la bénéficiaire qui vous ont conduit à la proposition de parcours
                          </label>
                          <textarea formControlName="supportChoiceExplanation" type="text" class="form-control"></textarea>
                        </div>
                      </div>
                    </ng-template>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- ********************************************************************************************* -->
      <!-- * Validation -->

      <div class="ms-auto">
        <small *ngIf="submitted && (assessmentForm.invalid || supportForm.invalid)" class="form-text text-danger">
          Le formulaire n'est pas correctement complété.
        </small>
      </div>
      <div class="row mt-4"></div>
    </div>

    <!-- ********************************************************************************************* -->
    <!-- * ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS * -->
    <!-- * ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS ACTION-BUTTONS * -->
    <!-- ********************************************************************************************* -->

    <div class="row px-3">
      <div class="col-6 col-md-9 col-lg-6 mb-2" *ngIf="!assessment?.id"></div>
      <div class="col-3 col-md-9 col-lg-3 mb-2" *ngIf="assessment?.id"></div>
      <ng-container *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION', 'DIRECTION+', 'TERRITORY']">
        <div ngbDropdown class="d-grid col-3 col-md-9 col-lg-3 mb-2" *ngIf="assessment?.id">
          <button class="btn btn-primary" id="dropdownActions" type="button" ngbDropdownToggle>
            <fa-icon icon="toolbox"></fa-icon>
            <span class="mx-3">Actions</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownActions">
            <!-- ********************************************************************************************* -->
            <!-- * Get PDF document -->

            <button class="btn btn-primary d-flex" type="button" ngbDropdownItem (click)="generateDocument()">
              <fa-icon icon="print"></fa-icon>
              <span class="ms-3 d-none d-md-block">Générer</span>
            </button>

            <!-- ********************************************************************************************* -->
            <!-- * Duplicate -->
            <ng-container>
              <button *ngIf="assessment.status === 'Validated'" type="button" class="btn btn-primary d-flex" (click)="duplicate()" ngbDropdownItem>
                <fa-icon icon="clone"></fa-icon>
                <span class="ms-3 d-none d-md-block">Dupliquer</span>
              </button>
            </ng-container>

            <!-- ********************************************************************************************* -->
            <!-- * Delete -->
            <ng-container *ngIf="!assessment.generatedSurveyFse">
              <button
                *appOnlyGroups="['ADMIN', 'STRUCTURE', 'DIRECTION+', 'TERRITORY']"
                type="button"
                class="btn btn-primary d-flex"
                (click)="delete()"
                ngbDropdownItem
              >
                <fa-icon icon="trash"></fa-icon>
                <span class="ms-3 d-none d-md-block">Supprimer</span>
              </button>
            </ng-container>
          </div>
        </div>
      </ng-container>

      <!-- ********************************************************************************************* -->
      <!-- * Cancel -->

      <div class="d-grid col-3 col-md-6 col-lg-3 mb-1">
        <button class="btn btn-primary d-flex justify-content-center" type="button" (click)="cancel()">
          <fa-icon icon="ban"></fa-icon>
          <span class="ms-3 d-none d-md-block">Annuler</span>
        </button>
      </div>

      <!-- ********************************************************************************************* -->
      <!-- * Save -->

      <ng-container *appOnlyGroups="['ADMIN', 'STRUCTURE', 'TERRITORY', 'DIRECTION+']">
        <div ngbDropdown class="d-grid col-3 col-md-6 col-lg-3 mb-1">
          <button class="btn btn-primary" id="dropdownActions" type="button" ngbDropdownToggle>
            <fa-icon icon="save"></fa-icon>
            <span class="mx-3">Sauvegarder</span>
          </button>

          <div ngbDropdownMenu aria-labelledby="dropdownActions">
            <button class="btn btn-primary d-flex" type="submit" ngbDropdownItem (click)="save(false)">
              <fa-icon icon="save"></fa-icon>
              <span class="ms-3 d-none d-md-block">Sauvegarder</span>
            </button>

            <button *ngIf="!assessment.generatedSurveyFse" type="button" class="btn btn-primary d-flex" (click)="save(true)" ngbDropdownItem>
              <fa-icon icon="save"></fa-icon>
              <span class="ms-3 d-none d-md-block">Sauvegarder et générer FSE</span>
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </form>
</div>
